import { render, staticRenderFns } from "./CreatorByTalentRepItem.vue?vue&type=template&id=0c212116&scoped=true&"
import script from "./CreatorByTalentRepItem.vue?vue&type=script&lang=ts&"
export * from "./CreatorByTalentRepItem.vue?vue&type=script&lang=ts&"
import style0 from "./CreatorByTalentRepItem.vue?vue&type=style&index=0&id=0c212116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c212116",
  null
  
)

export default component.exports